import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
const viewMode = wixWindow.viewMode;

$w.onReady(async function () {
	init();
	const initialData = await $w('#albumsGallery').onReady();
	refreshAlbumData(initialData);
	if (viewMode === "Preview") {
		$w('#albumsGallery').onRefreshHappened((data) => {
			refreshAlbumData(data);
		});
		$w('#albumsGallery').reportPageLoaded('sets');
	}
})

function init() {
	$w('#columnStrip2').hide && $w('#columnStrip2').hide()
	$w('#columnStrip3').hide && $w('#columnStrip3').hide()
	$w('#columnStrip4').show && $w('#columnStrip4').show()
	$w('#box16').hide && $w('#box16').hide()
}

function refreshAlbumData({albumData, sets}) {
	try {
		if (!albumData || !sets) {
			return;
		}
		if (albumData.hideLinkToCover) {
			$w('#back2GogBox').hide();
		}
		$w('#albumName').text = albumData.albumName;
		$w('#link2Gog').link = '/';
				$w('#link2Cover').link = '/';

		$w('#gallery').items = albumData.gogItems;
		$w('#gallery').options = albumData.gogOptions;
		$w('#gallery').onItemClicked((result) => {
			wixLocation.to(result.item.link)
		});
	} catch (e) {
		console.error("Error_On_Page", e);
	}
}

$w.onReady(function () {
	$w('#facebook').link = `https://www.facebook.com/sharer/sharer.php?u=${wixLocation.url}`;
	$w('#facebook').target = "_blank"

	$w('#twitter').link = `http://twitter.com/share?url=${wixLocation.url}`;
	$w('#twitter').target = "_blank";

	$w('#pinterest').link = `http://pinterest.com/pin/create/button/?url=${wixLocation.url}`;
	$w('#pinterest').target = "_blank";

	$w('#tumblr').link = `http://tumblr.com/share/link?url=${wixLocation.url}`;
	$w('#tumblr').target = "_blank";

	$w('#mail').link = `mailto:?body=Check out this site%0D%0A${wixLocation.url}.&subject=I wanted you to see this site`;
	$w('#mail').target = "_blank";

});